<template>
  <div>
    <div class="d-flex align-items-center" style="margin-top: 12px;">
      <div>
        <h5 class="mb-0">Словарь Бюджет</h5>
        <div class="fs12px lh12px">
          <em>
            Данный словарь используется для создания статей бюджета в таблице. Можно менять порядок и переименовывать свойства. 
          </em>
        </div>
      </div>
      <div class="d-flex ml-auto align-items-center">
        <label class="mb-0 mr-2">Юнит:</label>
        <b-form-select
          v-model="selectedUnit"
          :options="unitOptions"
          size="sm"
          class="mr-3"
          style="width: 120px;"
          @change="getDictionary()"
        />
        <div>
          <input class="form-control table-input-search" type="search" placeholder="Поиск" v-model="filter">
        </div>
        <b-button
          @click="getDictionary()"
          size="sm"
          variant="outline-secondary"
          class="ml-2"
          :disabled="loading"
        >
          <b-icon icon="arrow-repeat" scale="1.5" :animation="loading ? 'spin' : ''"></b-icon>
        </b-button>
        <button
          :disabled="loading"
          @click="openCreate()"
          class="btn btn-outline-primary ml-2"
        >
          Создать запись
        </button>
      </div>
    </div>
    <h5 class="mt-5 mb-4">Список статей (группы и подгруппы) — {{ selectedUnit }}</h5>
    <Bdr2026NestedRecords
      :records="filtredItems"
      :level="1"
      :parent-options="parentOptions"
      :expanded-ids="expandedIds"
      :allow-reorder="false"
      @update-item="getDictionary"
      @toggle-expanded="toggleExpanded"
      @edit="onEdit"
    />
    <Bdr2026DictionarySidebar
      :isOpen.sync="isOpen"
      :editedItem.sync="editedItem"
      :parent-options="parentOptions"
      :current-unit="selectedUnit"
      @updateItem="getDictionary"
    />
  </div>
</template>

<script>
import { API_BDR2026_DICTIONARY } from '@/constants';
import Bdr2026NestedRecords from '@/components/bdrPage/Bdr2026NestedRecords.vue';
import Bdr2026DictionarySidebar from '@/components/bdrPage/Bdr2026DictionarySidebar.vue';

export default {
  name: 'BDR2026Dictionary',
  components: {
    Bdr2026NestedRecords,
    Bdr2026DictionarySidebar
  },
  data() {
    return {
      loading: false,
      dictionary: [],
      filter: '',
      selectedUnit: 'B2B',
      unitOptions: [
        { value: 'B2B', text: 'B2B' },
        { value: 'B2C', text: 'B2C' },
        { value: 'БСЗ', text: 'БСЗ' }
      ],
      parentOptions: [{ text: '0: Корневая группа', value: 0 }],
      isOpen: false,
      editedItem: { name: '', parent_id: 0, unit: 'B2B', is_expense: false },
      expandedIds: {}
    };
  },
  computed: {
    filtredItems() {
      if (!this.filter) return this.dictionary;
      const search = this.filter.toLowerCase();
      return this.dictionary.filter(item => this.matchesSearch(item, search));
    }
  },
  mounted() {
    this.getDictionary();
  },
  methods: {
    getDictionary() {
      this.loading = true;
      const unit = this.selectedUnit || 'B2B';
      axios.get(`${API_BDR2026_DICTIONARY}?easylist=true&unit=${encodeURIComponent(unit)}`).then(({ data }) => {
        this.dictionary = data || [];
        this.parentOptions = [{ text: '0: Корневая группа', value: 0 }];
        this.formParentOptions(this.dictionary, '');
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    formParentOptions(list, prefix) {
      (list || []).forEach(rec => {
        this.parentOptions.push({
          value: rec.id,
          text: `${prefix}${rec.id}: ${rec.name}`
        });
        if (rec.children && rec.children.length) {
          this.formParentOptions(rec.children, prefix + '—');
        }
      });
    },
    matchesSearch(item, search) {
      if (item.name && item.name.toLowerCase().includes(search)) return true;
      if (item.children) {
        for (const child of item.children) {
          if (this.matchesSearch(child, search)) return true;
        }
      }
      return false;
    },
    openCreate() {
      this.editedItem = { name: '', parent_id: 0, unit: this.selectedUnit || 'B2B', is_expense: false };
      this.isOpen = true;
    },
    onEdit(record) {
      this.editedItem = {
        id: record.id,
        name: record.name,
        parent_id: record.parent_id || 0,
        unit: record.unit || this.selectedUnit || 'B2B',
        is_expense: !!record.is_expense
      };
      this.isOpen = true;
    },
    toggleExpanded(id) {
      const cur = !!this.expandedIds[id];
      this.$set(this.expandedIds, id, !cur);
    }
  }
};
</script>
